import _extends from "@babel/runtime/helpers/extends";
import React, { Fragment, memo, Suspense } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { DebounceLoader } from "../Loader";
var StatelessModal = function StatelessModal(_ref) {
  var show = _ref.show,
    hideModal = _ref.hideModal,
    children = _ref.children,
    Title = _ref.Title,
    Body = _ref.Body,
    Footer = _ref.Footer,
    loaded = _ref.loaded,
    backdrop = _ref.backdrop,
    customProps = _ref.customProps;
  return /*#__PURE__*/React.createElement(Fragment, null, children(), /*#__PURE__*/React.createElement(Modal, _extends({
    backdrop: backdrop,
    show: show,
    onHide: hideModal
  }, customProps), /*#__PURE__*/React.createElement(DebounceLoader, {
    loaded: loaded
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, null, /*#__PURE__*/React.createElement(Title, null))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "stateless-modal-body"
  }, /*#__PURE__*/React.createElement(Body, {
    hideModal: hideModal
  }))), Footer !== null && /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(Footer, {
    hideModal: hideModal
  }))))));
};
StatelessModal.defaultProps = {
  customProps: null,
  Footer: null,
  loaded: true,
  backdrop: true,
  children: function children() {}
};
StatelessModal.propTypes = {
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  children: PropTypes.func,
  Title: PropTypes.elementType.isRequired,
  Body: PropTypes.elementType.isRequired,
  Footer: PropTypes.elementType,
  loaded: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  customProps: PropTypes.shape({
    size: PropTypes.string,
    bsSize: PropTypes.string
  })
};
export default /*#__PURE__*/memo(StatelessModal);